import * as types from '@/org-app/store/modules/lifesightAudienceSegments/mutation-types';

const mutations = {
  [types.GET_LIFESIGHT_AUDIENCE_SEGMENTS](state, segments) {
    state.lifesightAudienceSegments = segments;
  },
  [types.GET_LIFESIGHT_COUNTRIES_AND_CATEGORIES](state, data) {
    const { categories, locations } = data;
    state.lifesightCategories = categories;
    state.lifesightLocations = locations;
  },
  [types.GET_ALL_LIFESIGHT_AUDIENCE_SEGMENTS](state, segments) {
    state.allLifesightSegments = segments;
  },
};

export default mutations;
